/** The integration setting holding its stock buffer (units held back per product). */
export const STOCK_BUFFER_SETTING = "stock_buffer_quantity"

/** The integration's stock buffer from its settings; null when none is set. */
export const readStockBuffer = (settings: { key: string; value: string }[]): number | null => {
  const value = settings.find((s) => s.key === STOCK_BUFFER_SETTING)?.value.trim() ?? ""
  return /^\d+$/.test(value) ? Number(value) : null
}

/** A typed whole-number field: empty is null; anything else must be a whole number of at least `min`. */
export const readWholeNumber = (text: string, min = 0): { value: number | null; invalid: boolean } => {
  const trimmed = text.trim()
  if (trimmed === "") return { value: null, invalid: false }
  const valid = /^\d+$/.test(trimmed) && Number(trimmed) >= min
  return { value: valid ? Number(trimmed) : null, invalid: !valid }
}
